<template>
  <v-container fluid>
    <v-tabs @change="updateEvent">
      <v-tab>Events</v-tab>
      <v-tab>Unchecked</v-tab>
      <v-tab>Errors</v-tab>
      <v-tab>Weekly</v-tab>
      <v-tab>Full statistic</v-tab>
      <v-tab>Holidays statistic</v-tab>
      <v-tab>Paid/Bonus</v-tab>
      <v-tab>Users</v-tab>
      <v-tab-item>
        <TimeTrackerEvent
            ref="timeTrackerEventFull"
            :unchecked-init="false" :deleted-init="true"></TimeTrackerEvent>
      </v-tab-item>
      <v-tab-item>
        <TimeTrackerEvent
            ref="timeTrackerEventUnchecked"
            :unchecked-init="true" :deleted-init="true"></TimeTrackerEvent>
      </v-tab-item>
      <v-tab-item>
        <ContractExecution ref="ContractExecution" dto_model="CalendarDateUserErrorDTO"></ContractExecution>
      </v-tab-item>
      <v-tab-item>
        <ContractWeekExecution ref="ContractWeekExecution" dto_model="CalendarDateUserWeekDTO"></ContractWeekExecution>
      </v-tab-item>
      <v-tab-item>
        <CalendarDateUserStatisticRange
            ref="CalendarDateUserStatisticRange"
            dto_model="CalendarDateUserStatisticRangeDTO"
        ></CalendarDateUserStatisticRange>
      </v-tab-item>
      <v-tab-item>
        <CalendarDateUserStatisticBegin
            ref="CalendarDateUserStatisticBegin"
            dto_model="CalendarDateUserStatisticBeginDTO"
        ></CalendarDateUserStatisticBegin>
      </v-tab-item>
      <v-tab-item>
        <Payed ref="Payed" dto_model="PayedEventDTO"></Payed>
      </v-tab-item>
      <v-tab-item>
        <HumanUserListCalendar
            ref="HumanUserListCalendar"
            dto_model="PayedEventDTO"
        ></HumanUserListCalendar>
      </v-tab-item>
    </v-tabs>
  </v-container>
</template>

<script>
import {debounce} from "debounce"
import {mapGetters, mapActions} from 'vuex';
import {mapFields} from 'vuex-map-fields';
import TimeTrackerEvent from "@/components/TimeTracker/TimeTrackerEvent";
import ContractExecution from "@/components/TimeTracker/ContractExecution";
import ContractWeekExecution from "@/components/TimeTracker/ContractWeekExecution";
import CalendarDateUserStatisticRange from "@/components/TimeTracker/CalendarDateUserStatisticRange";
import CalendarDateUserStatisticBegin from "@/components/TimeTracker/CalendarDateUserStatisticBegin";
import Payed from "@/components/TimeTracker/Payed";
import HumanUserListCalendar from "@/components/TimeTracker/HumanUserListCalendar";


export default {
  name: 'HRAdmin',
  props: {
    subtractHeight: {type: [Number], default: 150},
    height: {type: [Number], default: window.innerHeight},
  },

  components: {
    TimeTrackerEvent,
    ContractExecution,
    ContractWeekExecution,
    CalendarDateUserStatisticRange,
    CalendarDateUserStatisticBegin,
    Payed,
    HumanUserListCalendar,
  },

  computed: {},

  methods: {
    onResize() {
      // this.windowHeight = (window.innerHeight - this.subheight) + 'px'
      // console.log(this.$refs)
      let topHeight = 10
      if (this.$refs.RefListTop)
        topHeight = this.$refs.RefListTop.$el.clientHeight
      let footerHeight = 10
      if (this.$refs.RefListFooter)
        footerHeight = this.$refs.RefListFooter.clientHeight
      this.windowHeight = (window.innerHeight - this.subtractHeight - topHeight - footerHeight) + "px"
      // console.log('this.windowHeight', this.windowHeight)
    },
    updateEvent(event) {
      // console.log('updateEvent', this.$refs, event)
      if (event === 0 && this.$refs.timeTrackerEventFull) {
        this.$refs.timeTrackerEventFull.onUpdateFilters()
        return
      }
      if (event === 1 && this.$refs.timeTrackerEventUnchecked) {
        this.$refs.timeTrackerEventUnchecked.onUpdateFilters()
        return
      }
      if (event === 2 && this.$refs.ContractExecution) {
        this.$refs.ContractExecution.onUpdateFilters()
        return
      }
      if (event === 3 && this.$refs.ContractWeekExecution) {
        this.$refs.ContractWeekExecution.onUpdateFilters()
        return
      }
      if (event === 4 && this.$refs.CalendarDateUserStatisticRange) {
        this.$refs.CalendarDateUserStatisticRange.onUpdateFilters()
        return
      }
      if (event === 5 && this.$refs.Payed) {
        this.$refs.Payed.onUpdateFilters()
        return
      }
      if (event === 6 && this.$refs.HumanUserListCalendar) {
        this.$refs.HumanUserListCalendar.onUpdateFilters()
        return
      }
    },
  },

  async mounted() {
    // console.log('mounted')
    window.addEventListener("resize", this.onResize)
    this.onResize()
  },

  created() {
    window.addEventListener("resize", this.onResize);

  },
  destroyed() {
    window.removeEventListener("resize", this.onResize);
  },

  beforeDestroy() {
  },

  data: function () {
    return {
      windowHeight: (this.height - this.subheight) + 'px',
    }
  }
}

</script>

<style scoped lang="scss">

</style>
